import { render, staticRenderFns } from "./OttawaLab5ReportSheetPartCFr.vue?vue&type=template&id=36371669&"
import script from "./OttawaLab5ReportSheetPartCFr.vue?vue&type=script&lang=js&"
export * from "./OttawaLab5ReportSheetPartCFr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VSelect,VSimpleTable,VTextField})
